import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leadership-section',
  templateUrl: './leadership-section.component.html',
  styleUrls: ['./leadership-section.component.css']
})
export class LeadershipSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
